<script setup>
import { loadScript } from '@/utils/scriptLoader';
import { nextTick, onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
    buttonText: {
        type: String,
        default: '네이버로 로그인'
    }
});

const emit = defineEmits(['login-success', 'login-fail']);
const naverClientId = import.meta.env.VITE_NAVER_CLIENT_ID;
const baseUrl = import.meta.env.VITE_APP_BASE_URL;
const naverLoginRef = ref(null);
let checkInterval = null;

// 네이버 SDK 로드 및 초기화
const loadNaverSDK = async () => {
    try {
        await loadScript('https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js', {
            async: true,
            charset: 'utf-8'
        });

        // SDK 로드 확인
        return new Promise((resolve) => {
            if (window.naver_id_login) {
                resolve(true);
                return;
            }

            checkInterval = setInterval(() => {
                if (window.naver_id_login) {
                    clearInterval(checkInterval);
                    resolve(true);
                }
            }, 100);
        });
    } catch (error) {
        console.error('네이버 SDK 로드 실패:', error);
        emit('login-fail', { message: 'Naver SDK load failed', error });
        return false;
    }
};

// 네이버 로그인 초기화 함수
const initializeNaverLogin = () => {
    try {
        const naver_id_login = new window.naver_id_login(naverClientId, `${baseUrl}/login-auth`);
        const state = naver_id_login.getUniqState();

        // 로그인 버튼 초기화 및 설정
        naver_id_login.setButton('green', 3, 45);
        naver_id_login.setDomain(`${baseUrl}/login-auth`);
        naver_id_login.setState(state);
        //naver_id_login.setPopup(true);
        naver_id_login.init_naver_id_login(); // 초기화

        nextTick(() => {
            naverLoginRef.value = document.getElementById('naver_id_login').firstChild;
        });

        return true;
    } catch (error) {
        console.error('네이버 SDK 초기화 오류:', error);
        emit('login-fail', { message: 'Naver SDK init failed', error });
        return false;
    }
};

// 네이버 로그인 버튼 클릭 핸들러
const handleNaverLoginClick = () => {
    nextTick(() => {
        const naverLoginButton = document.getElementById('naver_id_login').firstChild;
        if (naverLoginButton) {
            naverLoginButton.click();
        } else {
            console.error('네이버 로그인 버튼을 찾을 수 없습니다');
            emit('login-fail', { message: 'Failed to trigger Naver login' });
        }
    });
};

onMounted(async () => {
    initializeNaverLogin();
    // const sdkLoaded = await loadNaverSDK();
    // if (sdkLoaded) {
    //     initializeNaverLogin();
    // }
});

onUnmounted(() => {
    if (checkInterval) {
        clearInterval(checkInterval);
    }
});
</script>

<template>
    <div>
        <div id="naver_id_login" style="display: none"></div>
        <button @click="handleNaverLoginClick" class="custom-naver-button">{{ props.buttonText }}</button>
    </div>
</template>

<style scoped>
.custom-naver-button {
    width: 100%;
    padding: 10px;
    background-color: #03c75a;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-family: 'SCoreDream400', sans-serif;
    font-size: 0.93rem;
    transition: background-color 0.2s;
}
.custom-naver-button:hover {
    background-color: #02b350;
}
</style>
